export const applyFormValidator = (values: any) => {
  const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const phoneRegex = /^[+()\d-]+$/
  const errors = {} as any

  if (!values.name) {
    errors.name = 'Required'
  }
  if (!values.company) {
    errors.company = 'Required'
  }
  if (!values.email) {
    errors.email = 'Required'
  } else if (!emailRegex.test(values.email.toLowerCase())) {
    errors.email = 'Invalid'
  }

  if (values.phone && !phoneRegex.test(values.phone)) {
    errors.phone = 'Invalid format'
  }

  return errors
}

export const applyFormInitialValues = {
  name: '',
  company: '',
  phone: '',
  position: '',
  email: '',
  imagesAmount: '',
  comment: ''
}
